import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { colors, fonts, spacing, radius, TAB_BAR_HEIGHT, APP_MAX_WIDTH } from "../theme";
import { useCookieNotice, registerReopenNotice } from "../hooks/useCookieNotice";

export default function CookieNotice({ withTabBar = true }) {
  const navigate = useNavigate();
  const { visible, acknowledge, reopen } = useCookieNotice();

  useEffect(() => {
    registerReopenNotice(reopen);
  }, [reopen]);

  if (!visible) return null;

  const bottom = (withTabBar ? TAB_BAR_HEIGHT : 0) + spacing.sm;

  return (
    <div
      className="pm-fade"
      style={{
        position: "fixed",
        bottom,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        maxWidth: APP_MAX_WIDTH,
        paddingLeft: spacing.md,
        paddingRight: spacing.md,
        zIndex: 200,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          pointerEvents: "auto",
          backgroundColor: colors.surfaceSecondary,
          borderRadius: radius.lg,
          border: `0.5px solid ${colors.border}`,
          padding: spacing.lg,
          boxShadow: "0 8px 28px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: spacing.sm }}>
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(196,164,100,0.10)",
              border: `0.5px solid ${colors.brandPrimary}`,
            }}
          >
            <Shield size={16} color={colors.brandPrimary} strokeWidth={1.75} />
          </div>
          <span style={{ fontFamily: fonts.display, fontSize: 17, fontWeight: 700, color: colors.onSurface, letterSpacing: 0.3 }}>
            Informativa
          </span>
        </div>
        <p style={{ fontFamily: fonts.body, fontSize: 12, lineHeight: "17px", color: colors.onSurfaceSecondary, marginTop: spacing.sm, marginBottom: 0 }}>
          Questo sito usa soltanto strumenti tecnici salvati sul tuo browser (ad es. per
          ricordare le modifiche fatte dal gestore al menu). Non usiamo analytics, cookie di
          profilazione o pixel di marketing.
        </p>
        <div style={{ display: "flex", gap: spacing.sm, marginTop: spacing.md }}>
          <button
            className="pm-press"
            onClick={() => navigate("/cookie-policy")}
            style={{
              flex: 1,
              border: `1px solid ${colors.brandSecondary}`,
              background: "transparent",
              paddingTop: 10,
              paddingBottom: 10,
              borderRadius: radius.md,
              color: colors.onBrandSecondary,
              fontFamily: fonts.body,
              fontWeight: 700,
              fontSize: 11,
              letterSpacing: 0.8,
              textTransform: "uppercase",
            }}
          >
            Cookie Policy
          </button>
          <button
            className="pm-press"
            onClick={acknowledge}
            style={{
              flex: 1,
              border: "none",
              backgroundColor: colors.brandPrimary,
              paddingTop: 10,
              paddingBottom: 10,
              borderRadius: radius.md,
              color: colors.onBrandPrimary,
              fontFamily: fonts.body,
              fontWeight: 700,
              fontSize: 11,
              letterSpacing: 0.8,
              textTransform: "uppercase",
            }}
          >
            Ho capito
          </button>
        </div>
      </div>
    </div>
  );
}
